/**
 * Hybrid CharacterCounter Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to the styled-components path when a styled-system prop is present
 * (hasStyledProps) or the component was extended with styled()
 * (isStyledExtension). Otherwise renders the Tailwind path. CharacterCounter's
 * container only applies the COMMON mixin (not BORDER), so no hasBorderProps
 * check is needed.
 */

import * as React from "react";
import {
  hasStyledProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";
import type { TypeCharacterCounterProps } from "./CharacterCounterTypes";
import CharacterCounterStyled from "./CharacterCounterStyled"; // Styled-components version
import { CharacterCounterTailwind } from "./CharacterCounterTailwind"; // Tailwind version

const CharacterCounterHybrid = React.forwardRef<
  HTMLDivElement,
  TypeCharacterCounterProps
>((props, ref) => {
  if (hasStyledProps(props) || isStyledExtension(props)) {
    return <CharacterCounterStyled {...props} ref={ref} />;
  }

  // Use Tailwind version (preferred - better performance)
  return <CharacterCounterTailwind {...props} ref={ref} />;
});

CharacterCounterHybrid.displayName = "CharacterCounter";
export default CharacterCounterHybrid;
